import { useEffect, useState } from "react";
import "../Volunteer_step_form.css";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { useFormContext, Controller } from "react-hook-form";
import Light_Black_Btn from "../../../common/common_btn/light_black_btn/Light_Black_Btn";
import Successfull_Modal from "../../../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  AllHoursOfService,
  AllDaysOfService,
  AllVolunteerPositon,
} from "../../../../features/admin/common/Slice";
import { StepTwo } from "../../../../features/admin/volunteerStepform/Slice";
import { useNavigate } from "react-router-dom";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Step_two = ({ prevStep, nextStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const all_hours_of_service = useSelector(
    (state) => state.common.all_hours_of_service,
  );
  const all_days_of_service = useSelector(
    (state) => state.common.all_days_of_service,
  );
  const all_volunteer_position = useSelector(
    (state) => state.common.all_volunteer_position,
  );

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const [successModal, setSuccessModal] = useState(false);

  useEffect(() => {
    dispatch(AllHoursOfService());
    dispatch(AllDaysOfService());
    dispatch(AllVolunteerPositon());
  }, [dispatch]);

  // Convert API data to Select options dynamically
  const serviceHoursOpt =
    all_hours_of_service?.map((item) => ({
      value: item.id,
      label: item.name,
    })) || [];

  const serviceDaysOpt =
    all_days_of_service?.map((item) => ({
      value: item.id,
      label: item.name,
    })) || [];

  const volunteerPosOpt =
    all_volunteer_position?.map((item) => ({
      value: item.id,
      label: item.name,
    })) || [];

  const onSubmit = async (values) => {
    try {
      const sendData = new FormData();

      sendData.append(
        "volunteer_position_id",
        values?.volunteer_position_id || "",
      );
      sendData.append("days_of_service_id", values?.days_of_service_id || "");
      sendData.append("hours_of_service_id", values?.hours_of_service_id || "");
      sendData.append(
        "learn_about_this_opening",
        values?.learn_about_this_opening || "",
      );
      sendData.append("want_volunteer", values?.want_volunteer || ""); // radio: Part Time / Full Time
      sendData.append(
        "have_you_volunteered",
        values?.have_you_volunteered || "",
      ); // text
      sendData.append("joining_date", values?.joining_date || "");
      sendData.append("skills", values?.skills || "");
      sendData.append("live_omtapovan", values?.live_omtapovan ? true : false);

      sendData.append("your_confirmation", values?.your_confirmation || "");

      // volunteer_id from Step-1
      if (values?.volunteer_id) {
        sendData.append("volunteer_id", values.volunteer_id);
      }

      const response = await dispatch(StepTwo(sendData)).unwrap();

      if (response?.message) {
        localStorage.removeItem("volunteer_id");
        setSuccessModal(true);
        setTimeout(() => {
          setSuccessModal(false);
          navigate("/home");
          nextStep();
        }, 1500);
      }
    } catch (error) {
      console.error("Step-2 Error:", error);
    }
  };

  window.addEventListener("beforeunload", (e) => {
    e.preventDefault();
    e.returnValue = "";
  });

  return (
    <>
      <div className="form_sec">
        <div className="row">
          <div className="col-lg-9 mx-auto">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <button className="backbtn" type="button" onClick={prevStep}>
                back
              </button>

              <div className="row">
                {/* Volunteer Position */}
                <div className="col-md-12 mb-3">
                  <div className="form-group">
                    <Form.Label>
                      Volunteer position(s) you are applying for (e.g., Cook?
                      Housekeeper? Maintenance?)
                    </Form.Label>
                    <Controller
                      name="volunteer_position_id"
                      control={control}
                      rules={{ required: "Please select volunteer position" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={volunteerPosOpt}
                          value={
                            volunteerPosOpt.find(
                              (opt) =>
                                opt.value === watch("volunteer_position_id"),
                            ) || null
                          }
                          onChange={(selected) =>
                            setValue("volunteer_position_id", selected?.value, {
                              shouldValidate: true,
                            })
                          }
                        />
                      )}
                    />
                    {errors.volunteer_position_id && (
                      <p className="text-danger">
                        {errors.volunteer_position_id.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Days */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <Form.Label>Days of Service</Form.Label>
                    <Controller
                      name="days_of_service_id"
                      control={control}
                      rules={{ required: "Please select days of service" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={serviceDaysOpt}
                          value={
                            serviceDaysOpt.find(
                              (opt) =>
                                opt.value === watch("days_of_service_id"),
                            ) || null
                          }
                          onChange={(selected) =>
                            setValue("days_of_service_id", selected?.value, {
                              shouldValidate: true,
                            })
                          }
                        />
                      )}
                    />
                    {errors.days_of_service_id && (
                      <p className="text-danger">
                        {errors.days_of_service_id.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Hours */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <Form.Label>Hours of Service</Form.Label>
                    <Controller
                      name="hours_of_service_id"
                      control={control}
                      rules={{ required: "Please select hours of service" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={serviceHoursOpt}
                          value={
                            serviceHoursOpt.find(
                              (opt) =>
                                opt.value === watch("hours_of_service_id"),
                            ) || null
                          }
                          onChange={(selected) =>
                            setValue("hours_of_service_id", selected?.value, {
                              shouldValidate: true,
                            })
                          }
                        />
                      )}
                    />
                    {errors.hours_of_service_id && (
                      <p className="text-danger">
                        {errors.hours_of_service_id.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Learn About Opening */}
                <div className="col-md-12 mb-3">
                  <div className="form-group">
                    <Form.Label>
                      How Did You Learn About This Opening?
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Type here"
                      {...register("learn_about_this_opening", {
                        required: "Please enter how you learned about opening",
                      })}
                    />
                    {errors.learn_about_this_opening && (
                      <p className="text-danger">
                        {errors.learn_about_this_opening.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* How do you want to volunteer? (radio) */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <Form.Label>How do you want to volunteer?</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        label="Part Time"
                        type="radio"
                        value="Part Time"
                        {...register("want_volunteer", {
                          required: "Please select volunteering type",
                        })}
                      />
                      <Form.Check
                        inline
                        label="Full Time"
                        type="radio"
                        value="Full Time"
                        {...register("want_volunteer", {
                          required: "Please select volunteering type",
                        })}
                      />
                    </div>
                    {errors.want_volunteer && (
                      <p className="text-danger">
                        {errors.want_volunteer.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Have you volunteered before? */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <Form.Label>
                      Have You Volunteered For Us Before? If Yes, When?
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Type here"
                      {...register("have_you_volunteered", {
                        required: "Please provide volunteering history",
                      })}
                    />
                    {errors.have_you_volunteered && (
                      <p className="text-danger">
                        {errors.have_you_volunteered.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* Joining Date */}
                {/* <div className="col-md-12 mb-3">
                <div className='form-group'>
                <Form.Label>If Accepted, On What Date Will You Be Available To Start?</Form.Label>
                <Form.Control
                  type="date"
                  min={new Date().toISOString().split("T")[0]}
                  {...register("joining_date", {
                    required: "Please select joining date",
                  })}
                />
                {errors.joining_date && (
                  <p className="text-danger">{errors.joining_date.message}</p>
                )}
              </div>
              </div> */}

                <div className="col-md-12 mb-3">
                  <Form.Group className="gray_input_group">
                    <Form.Label>
                      If Accepted, On What Date Will You Be Available To Start?
                    </Form.Label>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Controller
                        name="joining_date"
                        control={control}
                        rules={{
                          required: "Please select joining date",
                        }}
                        render={({ field }) => (
                          <DatePicker
                            label="Select Joining Date"
                            minDate={dayjs()} // ✅ no past dates
                            value={field.value ? dayjs(field.value) : null}
                            onChange={(newValue) => {
                              const formattedDate = newValue
                                ? newValue.format("YYYY-MM-DD")
                                : null;
                              field.onChange(formattedDate);
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errors?.joining_date,
                                helperText: errors?.joining_date?.message,
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Form.Group>
                </div>

                {/* Skills */}
                <div className="col-md-12 mb-3">
                  <div className="form-group">
                    <Form.Label>
                      Are There Any Other Experiences Or Skills?
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Type here"
                      {...register("skills", {
                        required: "Please enter your skills",
                      })}
                    />
                    {errors.skills && (
                      <p className="text-danger">{errors.skills.message}</p>
                    )}
                  </div>
                </div>
                {/* Live at Ashram */}
                <div className="col-md-12 mb-3">
                  <div className="form-group">
                    <Form.Label>
                      If accepted, do you wish to live at Om Tapovan Ashram?
                    </Form.Label>
                    <div>
                      <Form.Check
                        inline
                        label="Yes"
                        type="radio"
                        value="true"
                        {...register("live_omtapovan", {
                          required: "Please select one",
                        })}
                      />
                      <Form.Check
                        inline
                        label="No"
                        type="radio"
                        value="false"
                        {...register("live_omtapovan", {
                          required: "Please select one",
                        })}
                      />
                    </div>
                    {errors.live_omtapovan && (
                      <p className="text-danger">
                        {errors.live_omtapovan.message}
                      </p>
                    )}
                  </div>
                </div>
                {/* 18+ check */}
                <div className="col-md-12 mb-3">
                  <div className="form-group">
                    <Form.Label>Are you over 18 years of age?</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        label="Yes"
                        type="radio"
                        value="Yes"
                        {...register("your_confirmation", {
                          required: "Please confirm your age",
                        })}
                      />
                      <Form.Check
                        inline
                        label="No"
                        type="radio"
                        value="No"
                        {...register("your_confirmation", {
                          required: "Please confirm your age",
                        })}
                      />
                    </div>
                    {errors.your_confirmation && (
                      <p className="text-danger">
                        {errors.your_confirmation.message}
                      </p>
                    )}
                  </div>
                </div>
                {/* Agree checkbox */}
                <div className="col-md-12 mb-3">
                  <div className="form-group">
                    <Form.Check
                      label="By using this form you agree with the storage and handling of your data by this website."
                      type="checkbox"
                      {...register("agree_policy", {
                        required: "You must agree before submitting",
                      })}
                    />
                    {errors.agree_policy && (
                      <p className="text-danger">
                        {errors.agree_policy.message}
                      </p>
                    )}
                  </div>
                </div>
                {/* Submit */}
                <div className="col-md-12 mt-4">
                  <Light_Black_Btn
                    btnText="Submit"
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </Form>
          </div>
        </div>

        <Successfull_Modal
          show={successModal}
          onHide={() => setSuccessModal(false)}
          headtext={"Application for Volunteering"}
          successfultext={"Application Submitted Successfully!"}
          subtext={"See You Soon!"}
          subtext2={"Have a nice time ahead"}
        />
      </div>
    </>
  );
};

export default Step_two;

// import { useState, useEffect } from "react";
// import '../Volunteer_step_form.css'
// import { Button, Form } from "react-bootstrap";
// import Select from 'react-select'
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import { useForm, Controller } from "react-hook-form";
// import Light_Black_Btn from "../../../common/common_btn/light_black_btn/Light_Black_Btn";
// import Common_Back_Header from "../../../common/common_components/common_back_header/Common_Back_Header";
// import Successfull_Modal from "../../../common/modals/common-modal/successfull_modal/Successfull_Modal";
// import { AllHoursOfService, AllDaysOfService ,AllVolunteerPositon} from '../../../../features/admin/common/Slice';
// import { useDispatch, useSelector } from 'react-redux';

// const Step_two = ({ prevStep, nextStep }) => {

//   const dispatch = useDispatch();

//   const all_hours_of_service = useSelector((state) => state.common.all_hours_of_service);
//   const all_days_of_service = useSelector((state) => state.common.all_days_of_service);
//   const all_volunteer_position = useSelector((state) => state.common.all_volunteer_position);

//   console.log("all_hours_of_serviceall_hours_of_serviceall_hours_of_service",all_hours_of_service)
//   console.log("all_days_of_serviceall_days_of_serviceall_days_of_service",all_days_of_service)
//   console.log("all_volunteer_positionall_volunteer_positionall_volunteer_position",all_volunteer_position)

//   useEffect(() => {
//     dispatch(AllHoursOfService());
//     dispatch(AllDaysOfService());
//     dispatch(AllVolunteerPositon());
//   }, [dispatch]);

//   const [successModal, setSuccessModal] = useState(false);

//   const options = [
//     { value: 'chocolate', label: 'Chocolate' },
//     { value: 'strawberry', label: 'Strawberry' },
//     { value: 'vanilla', label: 'Vanilla' }
//   ];

//   const {
//     control,
//     reset,
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();

//   return (
//     <>
//       <div className='form_sec'>
//         <div className='row'>
//           <div className='col-lg-9 mx-auto'>
//             <Form>
//               {/* <Common_Back_Header  /> */}
//               <button className="backbtn" onClick={prevStep}>back</button>
//               <div className='row'>
//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>Volunteer position(s) you are applying for (e.g., Cook? Housekeeper? Maintenance?)</Form.Label>
//                     <Select options={options} />
//                   </div>
//                 </div>
//                 <div className='col-md-6 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>Days of Service</Form.Label>
//                     <Select options={options} />
//                   </div>
//                 </div>
//                 <div className='col-md-6 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>Hours of Service</Form.Label>
//                     <Select options={options} />
//                   </div>
//                 </div>
//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>How Did You Learn About This Opening?</Form.Label>
//                     <Form.Control as="textarea" type="text" placeholder="Type here" />
//                   </div>
//                 </div>
//                 <div className='col-md-6 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>How do you want to volunteer?</Form.Label>
//                     <div>
//                       <Form.Check
//                         inline
//                         label="Part Time"
//                         name="group"
//                         type="radio"
//                         id="nameone1"
//                       />
//                       <Form.Check
//                         inline
//                         label="Full Time"
//                         name="group"
//                         type="radio"
//                         id="nameone2"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className='col-md-6 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>Are you over 18 years of age?</Form.Label>
//                     <div>
//                       <Form.Check
//                         inline
//                         label="Yes"
//                         name="group"
//                         type="radio"
//                         id="nameone1"
//                       />
//                       <Form.Check
//                         inline
//                         label="No"
//                         name="group"
//                         type="radio"
//                         id="nameone2"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>Have You Volunteered For Us Before?  If Yes, When?</Form.Label>
//                     <Form.Control type="text" placeholder="Type here" />
//                   </div>
//                 </div>
//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>If Accepted, On What Date Will You Be Available To Start?</Form.Label>
//                     <Form.Control type="date" placeholder="Type here" />
//                   </div>
//                 </div>
//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>Are There Any Other Experiences Or Skills?</Form.Label>
//                     <Form.Control type="text" placeholder="Type here" />
//                   </div>
//                 </div>

//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Label>If accepted, do you wish to live at Om Tapovan Ashram?</Form.Label>
//                     <div>
//                       <Form.Check
//                         inline
//                         label="Yes"
//                         name="group"
//                         type="radio"
//                         id="nameone1"
//                       />
//                       <Form.Check
//                         inline
//                         label="No"
//                         name="group"
//                         type="radio"
//                         id="nameone2"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className='col-md-12 mb-3'>
//                   <div className='form-group'>
//                     <Form.Check
//                       inline
//                       label="By using this form you agree with the storage and handling of your data by this website."
//                       name="group"
//                       type="checkbox"
//                       id="nameone1"
//                     />
//                   </div>
//                 </div>

//                 <div className='col-md-12 mt-4'>
//                   <Light_Black_Btn btnText={'Submit'} onClick={() => setSuccessModal(true)} />
//                 </div>

//               </div>
//             </Form>
//           </div>
//         </div>

//         <Successfull_Modal
//           show={successModal}
//           onHide={() => setSuccessModal(false)}
//           headtext={'Application for Volunteering'}
//           successfultext={'Application Submited Successfully!'}
//           subtext={'See You Soon!'}
//           subtext2={'Have a nice time ahead'}
//         />
//       </div>
//     </>
//   )
// }

// export default Step_two
